export const createAction = (type: string) => (
  payload?: Object | Array<any> | string | number,
) => ({type, payload});
